// extracted by mini-css-extract-plugin
export var acitonButtons = "_bb-0";
export var additionalIcon = "_bb-f";
export var block = "_bb-1";
export var blockContent = "_bb-7";
export var blockDescription = "_bb-8";
export var blockIcon = "_bb-9";
export var blockTitle = "_bb-6";
export var border = "_bb-a";
export var center = "_bb-l";
export var edge = "_bb-b";
export var edgeLabel = "_bb-c";
export var edgePath = "_bb-d";
export var error = "_bb-e";
export var flowchart = "_bb-g";
export var flowchartContent = "_bb-h";
export var highlighted = "_bb-3";
export var hover = "_bb-4";
export var icon = "_bb-i";
export var left = "_bb-m";
export var navButton = "_bb-j";
export var navButtons = "_bb-k";
export var right = "_bb-n";
export var selected = "_bb-2";
export var small = "_bb-5";